<template>
  <div>
    <div v-if="user" id="design">
      <nav class="navbar sticky-top navbar-light bg-light">
        <div class="navbar-brand text-truncate">
          <!-- Placeholder for user profile-->
          <button
            type="button"
            class="btn btn-outline-danger ml-1"
            data-toggle="modal"
            data-target="#userProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="id-badge" />
          </button>
          <button
            type="button"
            class="btn btn-outline-success ml-1"
            data-toggle="modal"
            data-target="#infoProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="info" />
          </button>
          <span class="h4 text-success text-capitalize ml-2"
            >{{ selectedTypeName }} System</span
          >
          <div class="mt-2 text-sm text-secondary text-truncate">
            <span v-if="info.box_id != 0">
              <span class="h4 text-success">Box {{ info.box_id }}: </span>
              <span class="h4" v-bind:class="info.boxBarStyle">{{
                info.boxBar
              }}</span>
              <span v-if="info.seq" class="mx-1 text-monospace">
                <span>{{ info.seq.substr(0, 40) }}</span>
                <span v-if="info.seq.length > 40">...</span>
              </span>
            </span>
          </div>
        </div>
        <div class="navbar-text ml-auto d-flex">
          <!-- Project profile button -->
          <button
            v-if="selectedProject"
            type="button"
            class="btn btn-outline-success ml-1"
            data-toggle="modal"
            data-target="#projectProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="project-diagram" />
          </button>

          <div v-if="selectedCart">
            <button
              type="button"
              class="btn btn-outline-success ml-1"
              data-toggle="modal"
              data-target="#cartProfile"
              data-backdrop="static"
              data-keyboard="false"
            >
              <span v-if="!cartIsFull" class="badge badge-pill badge-light">{{
                cartQty
              }}</span>
              <span v-if="cartIsFull" class="badge badge-pill badge-danger">{{
                cartQty
              }}</span>
              <font-awesome-icon icon="shopping-cart" />
            </button>
          </div>
        </div>
        <!-- .navbar-text ml-auto d-flex -->
      </nav>
      <!-- sticky top -->

      <!-- userProfile -->
      <OlabUserProfile :user="user" />

      <!-- infoProfile -->
      <OlabInfoProfile
        :user="user"
        :selectedTypeName="selectedTypeName"
        :cstComp="cstComp"
      />

      <!-- projectProfile -->
      <OlabProjectProfile :user="user" :project="selectedProject" />

      <!-- cartProfile -->
      <OlabCartProfile
        :user="user"
        :selectedProject="selectedProject"
        :selectedCart="selectedCart"
      />

      <article
        v-if="selectedCart"
        class="page-design text-center py-3"
        id="page-design"
      >
        <header class="page-design-header container mb-3">
          <div class="row justify-content-center">
            <div class="col-11">
              <h2>Gene Design</h2>
              <div class="form-group">
                <!-- <legend>Box info</legend> -->
                <select
                  class="form-control"
                  id="numOfBoxes"
                  v-on:click="initComps()"
                  v-model="numOfBoxes"
                >
                  <option disabled value="0">Select number of boxes</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                  <option value="4">Four</option>
                  <option value="5">Five</option>
                  <option value="6">Six</option>
                  <option value="7">Seven</option>
                  <option value="8">Eight</option>
                  <option value="9">Nine</option>
                  <option value="10">Ten</option>
                </select>
              </div>
              <!-- .form-group -->
              <div class="container">
                <div class="row justify-content-center">
                  <div v-for="(ccp, cstIndex) in cstComps" :key="cstIndex">
                    <div class="mb-2">
                      <button
                        class="btn mb-0 text-truncate"
                        v-bind:class="ccp.cstb.btn_color"
                        v-bind:style="boxStyle"
                        type="button"
                        v-on:click="registerCstComp(ccp)"
                        v-bind:disabled="ccp.cstb.btn_state == 'disabled'"
                      >
                        {{ ccp.cstb.display_name }}
                      </button>
                      <div
                        v-if="
                          ccp.item &&
                            ccp.item.comp &&
                            ccp.item.comp.olab_type == 'package'
                        "
                      >
                        <select
                          v-if="ccp.item.seq"
                          id="packageOption"
                          class="form-control text-truncate"
                          v-bind:style="boxStyle"
                          v-on:click="registerCstComp(ccp)"
                          v-model="ccp.cstb.package_op"
                        >
                          <option value="combination">Combination</option>
                          <option value="linear">Linear</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- .row -->
              </div>
              <!-- .container -->
              <!-- <div>
                <h2 class="text-warning mb-2">
                  <font-awesome-icon
                    class="ml-1 text-success"
                    icon="seedling"
                  ></font-awesome-icon>
                  Work in progress ...
                  <font-awesome-icon
                    class="ml-1 text-success"
                    icon="seedling"
                  ></font-awesome-icon>
                </h2>
              </div> -->
            </div>
          </div>
        </header>
        <section>
          <div class="accordion" id="accordion-design">
            <div class="card">
              <div class="card-header" id="heading-construct">
                <h2 class="mb-0">
                  <button
                    class="btn btn-info collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapse-construct"
                    aria-expanded="true"
                    aria-controls="collapse-construct"
                  >
                    Construct
                  </button>
                </h2>
              </div>
              <div
                id="collapse-construct"
                class="collapse show"
                aria-labelledby="heading-construct"
                data-parent="#accordion-design"
              >
                <div class="card-body">
                  <div class="container">
                    <div class="row justify-content-center">
                      <div class="col-10 col-md-6 col-lg-3">
                        <div class="form-group">
                          <legend>Box Type</legend>
                          <select
                            class="form-control"
                            id="selectedBoxType"
                            v-model="selectedBoxType"
                          >
                            <option disabled value="">Assign box type</option>
                            <option v-if="availBoxType.us_ds" value="up_stream"
                              >Up Stream</option
                            >
                            <option v-if="availBoxType.rbs" value="rbs"
                              >RBS</option
                            >
                            <option
                              v-if="availBoxType.promoter"
                              value="promoter"
                              >Promoter</option
                            >
                            <option v-if="availBoxType.gene" value="gene"
                              >Gene</option
                            >
                            <option v-if="availBoxType.pgst" value="pgst"
                              >PGsT</option
                            >
                            <option
                              v-if="availBoxType.terminator"
                              value="terminator"
                              >Terminator</option
                            >
                            <option
                              v-if="availBoxType.us_ds"
                              value="down_stream"
                              >Down Stream</option
                            >
                            <option value="unset">Unset</option>
                          </select>
                        </div>
                        <!-- .form-group -->
                      </div>
                      <div class="col-10 col-md-6 col-lg-3">
                        <div class="form-group">
                          <legend>Sequence</legend>
                          <select
                            class="form-control"
                            id="selectedSeq"
                            v-model="selectedSeq"
                          >
                            <option disabled value=""
                              >Assign sequence to box</option
                            >
                            <option
                              v-for="(cit, index) in filteredCartItems"
                              :key="index"
                              >{{ cit.comp.olab_id }}</option
                            >
                          </select>
                        </div>
                        <!-- .form-group -->
                      </div>
                      <div class="col-10 col-md-5 col-lg-2">
                        <div class="form-group">
                          <legend>Start</legend>
                          <input
                            class="form-control"
                            type="text"
                            v-bind:class="selectedStartValidState"
                            v-bind:disabled="
                              selectedStartDisabledState == 'disabled'
                            "
                            id="start"
                            v-model="selectedStart"
                          />
                          <small id="start-help" class="form-text text-muted">{{
                            selectedStartHelp
                          }}</small>
                          <div class="invalid-feedback">
                            Start has to be an integer
                          </div>
                        </div>
                        <!-- .form-group -->
                      </div>
                      <div class="col-10 col-md-5 col-lg-2">
                        <div class="form-group">
                          <legend>Range</legend>
                          <input
                            class="form-control"
                            type="text"
                            v-bind:class="selectedRangeValidState"
                            v-bind:disabled="
                              selectedRangeDisabledState == 'disabled'
                            "
                            id="range"
                            v-model="selectedRange"
                          />
                          <small id="range-help" class="form-text text-muted">{{
                            selectedRangeHelp
                          }}</small>
                          <div class="invalid-feedback">
                            Range has to be a positive non-zero integer
                          </div>
                        </div>
                        <!-- .form-group -->
                      </div>
                      <div
                        v-if="
                          cstComp &&
                            cstComp.item &&
                            cstComp.item.seq &&
                            cstComp.item.seq.olab_type == 'package' &&
                            cstComp.item.seq.package_seq_type == 'genome'
                        "
                        class="col-10 col-md-2 col-lg-2"
                      >
                        <div class="form-group">
                          <legend>Override</legend>
                          <div class="form-check pt-1">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="selectedOverride"
                            />
                          </div>
                        </div>
                        <!-- .form-group -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="heading-preview">
                <h2 class="mb-0">
                  <button
                    class="btn btn-info collapsed"
                    v-bind:disabled="previewDisabledState == 'disabled'"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapse-preview"
                    aria-expanded="false"
                    aria-controls="collapse-preview"
                    v-on:click="doPreview(false)"
                  >
                    <span
                      v-if="dsgn && dsgn.processing == 'preview'"
                      class="spinner-border spinner-border-sm text-light"
                    ></span>
                    Preview
                  </button>
                </h2>
              </div>
              <div
                id="collapse-preview"
                class="collapse"
                aria-labelledby="heading-preview"
                data-parent="#accordion-design"
              >
                <div
                  v-if="primerObjArr && primerObjArr.length > 0"
                  class="card-body"
                >
                  <div class="row justify-content-center">
                    <div class="col-12">
                      <div class="preview-primer">
                        <div class="card mb-2">
                          <div class="card-header text-dark h3">Assembly</div>
                          <div class="card-body">
                            <div class="form-group">
                              <legend>Length</legend>
                              <div class="row justify-content-center">
                                <div class="col-1"></div>
                                <div class="col-4">
                                  <div class="form-check form-check-inline">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="primerFullRadio"
                                      value="FULL"
                                      v-model="primerSetting"
                                    />
                                    <label
                                      class="form-check-label"
                                      for="primerFullRadio"
                                    >
                                      <span>Full</span>
                                      <span>
                                        <font-awesome-icon
                                          icon="arrows-alt-h"
                                        />
                                      </span>
                                    </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="primerFHalfRadio"
                                      value="FWD_HALF"
                                      v-model="primerSetting"
                                    />
                                    <label
                                      class="form-check-label"
                                      for="primerFHalfRadio"
                                    >
                                      <span>Half</span>
                                      <span>
                                        <font-awesome-icon
                                          icon="long-arrow-alt-right"
                                        />
                                      </span>
                                    </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="primerRHalfRadio"
                                      value="REV_HALF"
                                      v-model="primerSetting"
                                    />
                                    <label
                                      class="form-check-label"
                                      for="primerRHalfRadio"
                                    >
                                      <span>Half</span>
                                      <span>
                                        <font-awesome-icon
                                          icon="long-arrow-alt-left"
                                        />
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="col-6 d-flex justify-content-center"
                                >
                                  <div class="row justify-content-center">
                                    <div class="col-10 col-md-6 input-group">
                                      <div class="input-group-prepend">
                                        <label
                                          class="input-group-text"
                                          for="primer3pLength"
                                          >3'</label
                                        >
                                      </div>
                                      <select
                                        class="form-control"
                                        id="primer3pLength"
                                        v-model="primer3pLen"
                                      >
                                        <option
                                          v-for="(pmrLen,
                                          index) in primerLensOptArr"
                                          :key="index"
                                        >
                                          {{ pmrLen }}
                                        </option>
                                      </select>
                                    </div>
                                    <div class="col-10 col-md-6 input-group">
                                      <div class="input-group-prepend">
                                        <label
                                          class="input-group-text"
                                          for="primer5pLength"
                                          >5'</label
                                        >
                                      </div>
                                      <select
                                        class="form-control"
                                        id="primer5pLength"
                                        v-model="primer5pLen"
                                      >
                                        <option
                                          v-for="(pmrLen,
                                          index) in primerLensOptArr"
                                          :key="index"
                                        >
                                          {{ pmrLen }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-1"></div>
                              </div>
                              <div v-if="dsgn && dsgn.package_present">
                                <legend class="pt-3">
                                  {{ primerObjArr.length }} constructs generated
                                </legend>
                                <div class="pb-3">
                                  <div>
                                    {{ primerObjArr[pmrObjIndex].olab_id }}
                                  </div>
                                  <div>
                                    <span
                                      v-for="(cstb, index) in primerObjArr[
                                        pmrObjIndex
                                      ].cstbs"
                                      :key="index"
                                    >
                                      <span
                                        v-bind:class="cstb.use_seq_as_color"
                                      >
                                        {{ cstb.display_name }}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                                <div class="row py-1">
                                  <div
                                    class="col-10 col-md-8 mx-auto input-group"
                                  >
                                    <div class="input-group-prepend">
                                      <label
                                        class="input-group-text"
                                        for="selectConstruct"
                                        >Select a construct to verify</label
                                      >
                                    </div>
                                    <select
                                      class="form-control"
                                      id="selectConstruct"
                                      v-model="pmrObjIndex"
                                    >
                                      <option
                                        v-for="(prObj, pindex) in primerObjArr"
                                        :key="pindex"
                                      >
                                        {{ pindex }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <!-- construct -->
                                <OlabConstruct
                                  :pmrObj="primerObjArr[pmrObjIndex]"
                                />
                              </div>
                              <div v-else>
                                <div
                                  class="py-3"
                                  v-for="(prObj, pindex) in primerObjArr"
                                  :key="pindex"
                                >
                                  <!-- construct -->
                                  <OlabConstruct :pmrObj="prObj" />
                                </div>
                              </div>
                            </div>
                            <!-- .form-group -->
                            <div class="small text-secondary">
                              {{ meltTempNote }}
                            </div>
                          </div>
                          <!-- .card-body -->
                        </div>
                        <!-- .card -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="heading-decision">
                <h2 class="mb-0">
                  <button
                    class="btn btn-info collapsed"
                    v-bind:disabled="decisionDisabledState == 'disabled'"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapse-decision"
                    aria-expanded="false"
                    aria-controls="collapse-decision"
                    v-on:click="doDecision()"
                  >
                    <span
                      v-if="dsgn && dsgn.processing == 'decision'"
                      class="spinner-border spinner-border-sm text-light"
                    ></span>
                    Decision
                  </button>
                </h2>
              </div>
              <div
                id="collapse-decision"
                class="collapse"
                aria-labelledby="heading-decision"
                data-parent="#accordion-design"
              >
                <div v-if="dsgn && dsgn.cstArray" class="card-body">
                  <div class="decision-design">
                    <div class="card mb-2">
                      <div class="card-header text-dark h3">Design</div>
                      <div class="card-body mt-2">
                        <div class="h5 pt-2">OLAB ID: {{ dsgn.olab_id }}</div>
                        <form class="pt-3 container">
                          <fieldset class="form-group">
                            <div class="form-group row">
                              <label
                                class="pt-1 col form-control-label font-italic"
                              >
                                Name:
                              </label>
                              <input
                                class="col-11 col-md-10 col-sm-8 form-control"
                                type="text"
                                v-model="dsgnName"
                              />
                            </div>
                          </fieldset>
                        </form>
                        <div class="pt-1">
                          Project ID: {{ dsgn.project_id }}
                        </div>
                        <div class="pt-1">Cart ID: {{ dsgn.cart_id }}</div>
                        <div class="justify-content-center">
                          <legend class="pt-3">Generated</legend>
                          <div class="py-1">
                            <span class="font-italic mr-1">{{
                              dsgn && dsgn.cstArray.length
                            }}</span>
                            <span v-if="dsgn && dsgn.cstArray.length == 1"
                              >construct</span
                            >
                            <span v-else>constructs</span>
                          </div>
                          <div class="py-1">
                            <span class="font-italic mr-1"
                              >{{
                                dsgn && dsgn.combPmrArray.length
                              }}
                              primers</span
                            >
                          </div>
                          <div class="py-1 font-italic small">
                            of which
                          </div>
                          <div class="py-1">
                            <span class="font-italic mr-1"
                              >{{ dsgn && dsgn.uniqPmrArray.length }} unique
                              primers</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="mt-3 form-group">
                        <div class="mb-5 row justify-content-center">
                          <div class="col-1"></div>
                          <div class="col-10">
                            <button
                              class="mx-2 my-2 btn btn-info"
                              v-bind:disabled="
                                commitDesignDisabledState == 'disabled'
                              "
                              type="button"
                              v-on:click="doCommitDesign()"
                            >
                              <span
                                v-if="dsgn && dsgn.processing == 'commit'"
                                class="spinner-border spinner-border-sm text-light"
                              ></span>
                              Commit
                            </button>
                            <button
                              type="button"
                              class="mx-2 my-2 btn btn-info dropdown-toggle"
                              data-flip="false"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <span
                                v-if="dsgn && dsgn.processing == 'download'"
                                class="spinner-border spinner-border-sm text-light"
                              ></span>
                              Download
                              <span class="caret"></span>
                            </button>
                            <div class="dropdown-menu">
                              <a
                                class="dropdown-item"
                                href="#"
                                id="full-download"
                                v-on:click.prevent="doDownload('full')"
                              >
                                Full
                                <span v-if="selectedDownload === 'full'"
                                  >&#x2713;</span
                                >
                              </a>
                              <a
                                class="dropdown-item"
                                href="#"
                                id="order-download"
                                v-on:click.prevent="doDownload('order')"
                              >
                                Order
                                <span v-if="selectedDownload === 'order'"
                                  >&#x2713;</span
                                >
                              </a>
                            </div>
                            <button
                              class="mx-2 my-2 btn btn-info"
                              v-bind:disabled="resetDisabledState == 'disabled'"
                              type="button"
                              v-on:click="doReset()"
                            >
                              Reset
                            </button>
                          </div>
                          <div class="col-1"></div>
                        </div>
                      </div>
                      <!-- .form-group -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
      <article v-else class="page-design text-center py-5" id="page-design">
        <header class="page-design-header container">
          <p class="h3">Design Module requires a selected Cart to proceed.</p>
          <p class="h5">
            <span>Please select a cart from the</span>
            <span>
              <router-link to="/compdb" v-if="user"> Component </router-link>
            </span>
            <span>module.</span>
          </p>
        </header>
      </article>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import OlabConstruct from "@/components/OlabConstruct";
import OlabUserProfile from "@/components/OlabUserProfile";
import OlabInfoProfile from "@/components/OlabInfoProfile";
import OlabProjectProfile from "@/components/OlabProjectProfile";
import OlabCartProfile from "@/components/OlabCartProfile";
import { OlabCart } from "../olab/olabcart.js";
import { OlabComp } from "../olab/olabcomp.js";
import { OlabDesign } from "../olab/olabdesign.js";
import { OlabCstb } from "../olab/olabcstb.js";
import { OlabBlock } from "../olab/olabblock.js";
import { OlabDownload } from "../olab/olabdownload.js";
import { OlabUtils } from "../olab/olabutils.js";
// import firebase from "firebase";
// import db from "../olab/db.js";
import $ from "jquery";
import _ from "lodash";

export default {
  name: "design",
  data: function() {
    return {
      blockConfig: null,
      pmrObjIndex: 0,
      primerLensOptArr: [
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40
      ],
      boxStyle: {
        width: "80px",
        fontSize: "0.7em"
      },
      info: OlabCstb.info,
      availBoxType: OlabComp.availBoxType,
      filteredCartItems: null,
      cartItems: null,
      dsgn: null,
      dsgnName: null,
      cstComps: [],
      cstComp: null,
      lastCstComp: null,
      primer3pLen: 20,
      primer5pLen: 20,
      primerSetting: "FULL",
      primerObjArr: [],
      previewDisabledState: "disabled",
      commitDesignDisabledState: "disabled",
      resetDisabledState: "disabled",
      noSeqEval: false,
      noBoxTypeEval: false,
      noStartEval: false,
      noRangeEval: false,
      noOverrideEval: false,
      selectedItem: null,
      numOfBoxes: 0,
      lastNumOfBoxes: 0,
      selectedBox: 0,
      selectedBoxType: "",
      selectedSeq: "",
      selectedStart: "--",
      selectedStartValid: true,
      selectedStartDisabledState: "disabled",
      selectedStartHelp: "",
      selectedRange: "--",
      selectedRangeValid: true,
      selectedRangeDisabledState: "disabled",
      selectedRangeHelp: "",
      selectedOverride: false,
      selectedTypeName: "Box Design",
      selectedDownload: "",
      meltTempNote:
        "Note: Melting temperatures (Tm) above assume that the annealing occurs under the standard conditions of 50 nM primer, 50 mM Na+, and pH 7.0."
    };
  },
  components: {
    FontAwesomeIcon,
    OlabConstruct,
    OlabUserProfile,
    OlabInfoProfile,
    OlabProjectProfile,
    OlabCartProfile
  },
  props: [
    "user",
    "dbInfo",
    "selectedProject",
    "selectedCart",
    "selectedPackage",
    "error"
  ],
  mounted: function() {
    OlabUtils.infoLog("Design mounted ...");
    OlabCstb.resetInfoBox();
    if (this.selectedCart) {
      this.dsgn = new OlabDesign();
      this.dsgn.setCart(this.selectedCart, "box_design");

      OlabUtils.infoLog(" - selectedCart = " + this.selectedCart.olab_id);
      if (this.dsgn.name) {
        this.dsgnName = this.dsgn.name.slice(0);
      } else {
        this.dsgnName = "";
      }

      if (this.selectedCart.cstbs) {
        this.loadCstbs(this.selectedCart.cstbs);
      } else {
        // TODO: Create a new construct for this cart
      }
    } else {
      // selectedCart will be null temporarily when a user reload page
      // This reloadWorkaround is an attempt to catch such a situation
      OlabUtils.infoLog("selectedCart is null");
      this.reloadWorkaround();
    }
  },
  watch: {
    dsgnName: function() {
      OlabUtils.infoLog("dsgnName = " + this.dsgn.name);
      if (this.dsgnName != this.dsgn.name) {
        this.commitDesignDisabledState = "";
      }
    },
    primer3pLen: function() {
      if (this.cstComps.length > 0) {
        this.dsgn.pmr_3p_len = parseInt(this.primer3pLen);
        this.doPreview(true);
      }
    },
    primer5pLen: function() {
      if (this.cstComps.length > 0) {
        this.dsgn.pmr_5p_len = parseInt(this.primer5pLen);
        this.doPreview(true);
      }
    },
    primerSetting: function() {
      if (this.cstComps.length > 0) {
        this.dsgn.pmr_setting = this.primerSetting;
        this.doPreview(true);
      }
    },
    selectedOverride: function() {
      if (this.noOverrideEval) {
        this.noOverrideEval = false;
        return;
      }
      if (
        this.cstComp.item &&
        this.cstComp.item.comp.olab_type == "package" &&
        this.cstComp.item.seq &&
        this.cstComp.item.seq.package_seq_type == "genome"
      ) {
        OlabUtils.infoLog(
          "selectedOverride: override = " + this.selectedOverride
        );
        if (this.selectedOverride) {
          this.cstComp.item.seq.package_override = true;
          if (
            this.cstComp.cstb.start == "--" ||
            this.cstComp.cstb.range == "--"
          ) {
            this.cstComp.cstb.start = 0;
            this.cstComp.cstb.range = 100;
          }
          this.selectedStart = this.cstComp.cstb.start;
          this.selectedRange = this.cstComp.cstb.range;
        } else {
          this.cstComp.item.seq.package_override = false;
          this.cstComp.cstb.start = "--";
          this.cstComp.cstb.range = "--";
          // Restore seq back to gene's seq
          if (this.cstComp && this.cstComp.item) {
            OlabComp.restoreSeqGene(this.cstComp.item.seq);
          }
        }
        this.cstComp.cstb.package_override = this.cstComp.item.seq.package_override;
        this.setupStartAndRange(
          this.cstComp.item.comp.olab_type,
          this.cstComp.item.seq
        );
      }
    },
    selectedStart: function() {
      if (this.noStartEval) {
        this.noStartEval = false;
        return;
      }
      if (this.cstComp.item == null) {
        OlabUtils.infoLog(
          "selectStart: item == null, no start setting is needed"
        );
        return;
      }
      if (this.selectedSeq == "") {
        this.resetStartAndRange();
        return;
      }
      OlabUtils.infoLog("selectedStart = " + this.selectedStart);
      this.selectedStartValid =
        this.selectedStart.toString().match(/^[-+]?(0|[1-9]\d*)$/) != null;
      OlabUtils.infoLog("selectedStartValid = " + this.selectedStartValid);
      if (this.selectedStartValid) {
        let ciIndex = this.getCartItemIndex(this.selectedSeq);
        let item = this.cartItems[ciIndex];
        if (item != null) {
          this.cstComp.cstb.start = parseInt(this.selectedStart);

          if (this.cstComp.item.comp.olab_type == "strain") {
            this.computeSequence(
              this.cstComp.item.seq,
              parseInt(this.selectedStart),
              parseInt(this.selectedRange),
              this.cstComp,
              null
            );
          } else if (this.cstComp.item.comp.olab_type == "library_sequence") {
            this.computeLibrarySequence();
          } else if (
            this.cstComp.item.comp.olab_type == "package" &&
            this.cstComp.item.seq.package_seq_type == "genome"
          ) {
            OlabUtils.infoLog("selectedStart: processsing package ... ");
            if (this.cstComp.item.seq && this.cstComp.item.seq.comps) {
              const comps = this.cstComp.item.seq.comps;
              for (let i = 0; i < comps.length; i++) {
                this.computeSequence(
                  comps[i].seqGene,
                  parseInt(this.selectedStart),
                  parseInt(this.selectedRange),
                  null,
                  comps[i]
                );
              }
            }
          }

          // Set box's states into info as status
          OlabCstb.setInfoBox(this.cstComp);
          this.saveCstbs();
        }
      }
    },
    selectedRange: function() {
      if (this.noRangeEval) {
        this.noRangeEval = false;
        return;
      }
      if (this.cstComp.item == null) {
        OlabUtils.infoLog(
          "selectRange: item == null, no range setting is needed"
        );
        return;
      }
      if (this.selectedSeq == "") {
        this.resetStartAndRange();
        return;
      }
      OlabUtils.infoLog("selectedRange = " + this.selectedRange);
      this.selectedRangeValid =
        this.selectedRange.toString().match(/^[1-9]\d*$/) != null;
      OlabUtils.infoLog("selectedRangeValid = " + this.selectedRangeValid);

      // TODO: Remove limit to 20000 bases
      // This is due to FireBase limits of in array search to 10.
      // Note: 20000 limit is lower than 30000 (10 * blockSize (3000))
      if (this.selectedRange > 20000) {
        OlabUtils.warnLog("selectedRange exceeded 20000. CLAMP to MAX RANGE.");
        this.selectedRange = 20000;
      }
      // if (this.blockConfig) {
      //   if (this.selectedRange > this.blockConfig.total_seq_size) {
      //     OlabUtils.warnLog("selectedRange exceeded. CLAMP to MAX RANGE.");
      //     this.selectedRange = this.blockConfig.total_seq_size;
      //   }
      // }

      if (this.selectedRangeValid) {
        let ciIndex = this.getCartItemIndex(this.selectedSeq);
        let item = this.cartItems[ciIndex];
        if (item != null) {
          this.cstComp.cstb.range = parseInt(this.selectedRange);

          if (this.cstComp.item.comp.olab_type == "strain") {
            this.computeSequence(
              this.cstComp.item.seq,
              parseInt(this.selectedStart),
              parseInt(this.selectedRange),
              this.cstComp,
              null
            );
          } else if (this.cstComp.item.comp.olab_type == "library_sequence") {
            this.computeLibrarySequence();
          } else if (
            this.cstComp.item.comp.olab_type == "package" &&
            this.cstComp.item.seq.package_seq_type == "genome"
          ) {
            OlabUtils.infoLog("selectedRange: processsing package ... ");
            if (this.cstComp.item.seq && this.cstComp.item.seq.comps) {
              const comps = this.cstComp.item.seq.comps;
              for (let i = 0; i < comps.length; i++) {
                this.computeSequence(
                  comps[i].seqGene,
                  parseInt(this.selectedStart),
                  parseInt(this.selectedRange),
                  null,
                  comps[i]
                );
              }
            }
          } else {
            OlabUtils.infoLog("selectedRange: XXXX found none");
          }

          // Set box's states into info as status
          OlabCstb.setInfoBox(this.cstComp);
          this.saveCstbs();
        }
      }
    },
    selectedSeq: function() {
      OlabUtils.infoLog(
        "selectedSeq = " +
          this.selectedSeq +
          ", selectedBox = " +
          this.selectedBox
      );
      if (this.noSeqEval) {
        this.noSeqEval = false;
        return;
      }
      const isVisible = $("#collapse-preview").is(":visible");
      // OlabUtils.infoLog("selectedSeq: isVisible = " + isVisible);
      if (isVisible) {
        $("#collapse-preview").collapse("toggle");
      }

      if (this.selectedBoxType == "" && this.selectedSeq == "") {
        OlabUtils.infoLog("** New or unset cstComp selected **");
        return;
      }
      if (this.selectedSeq == "") {
        this.resetStartAndRange();
        return;
      }

      let ciIndex = this.getCartItemIndex(this.selectedSeq);
      this.cstComp.updateCartItem(ciIndex, this.cartItems);

      switch (this.cstComp.item.comp.olab_type) {
        case "strain" /* gene */:
          OlabUtils.infoLog(
            "selectedSeq: gene type: Extracted seq olab id = " +
              this.cstComp.item.seq.olab_id
          );
          // Set start to the begin of selected sequence
          this.selectedStart = 0;
          OlabUtils.infoLog("selectedStart = " + this.selectedStart);

          // Set range to the length of selected sequence
          this.selectedRange = this.getSeqLength(this.cstComp.item);
          OlabUtils.infoLog("selectedRange = " + this.selectedRange);

          this.computeSequence(
            this.cstComp.item.seq,
            this.selectedStart,
            this.selectedRange,
            this.cstComp,
            null
          );

          if (this.blockConfig) {
            this.setupStartAndRange(this.cstComp.item.comp.olab_type, "");
          } else {
            this.setupStartAndRange("unknown", "");
          }
          break;
        case "library_sequence" /* library_sequence */:
          OlabUtils.infoLog(
            "selectedSeq: library_sequence type: Extracted seq olab id = " +
              this.cstComp.item.seq.olab_id
          );
          // Set start to the begin of selected sequence
          this.selectedStart = 0;
          OlabUtils.infoLog("selectedStart = " + this.selectedStart);

          // Set range to the length of selected sequence
          this.selectedRange = this.getSeqLength(this.cstComp.item);
          OlabUtils.infoLog("selectedRange = " + this.selectedRange);

          this.cstComp.setSeq(this.cstComp.item.seq.seq);
          this.setupStartAndRange(this.cstComp.item.comp.olab_type, "");
          break;
        case "package" /* package */:
          OlabUtils.infoLog(
            "selectedSeq: package type: Extracted seq olab id = " +
              this.cstComp.item.seq.olab_id +
              " package_seq_type = " +
              this.cstComp.item.seq.package_seq_type
          );

          this.cstComp.setSeq(this.cstComp.item.seq.seq);

          if (this.cstComp.item.seq.package_seq_type == "genome") {
            OlabUtils.infoLog("genome case");
            // Reset package_override
            this.selectedOverride = false;
            this.cstComp.cstb.package_override = false;
            this.cstComp.item.seq.package_override = false;
            this.cstComp.cstb.start = "--";
            this.cstComp.cstb.range = "--";
            // Restore seq back to gene's seq
            if (this.cstComp && this.cstComp.item) {
              OlabComp.restoreSeqGene(this.cstComp.item.seq);
            }
          } else {
            // library_sequence case
            OlabUtils.infoLog("library_sequence case");
          }
          this.setupStartAndRange(
            this.cstComp.item.comp.olab_type,
            this.cstComp.item.seq
          );
          break;
        default:
          OlabUtils.infoLog(
            "selectedSeq: unknown type: Extracted seq id = " +
              this.cstComp.item.comp.olab_id +
              ", olab_type = " +
              this.cstComp.item.comp.olab_type +
              "****"
          );
          // Error!
          this.cstComp.setSeq("Unknown sequence type");

          // Disable setting for start and range
          this.selectedStartDisabledState = "disabled";
          this.selectedRangeDisabledState = "disabled";
      }

      // Set box's states into info as status
      OlabCstb.setInfoBox(this.cstComp);
      this.saveCstbs();
    },
    selectedBoxType: function() {
      if (this.noBoxTypeEval) {
        this.noBoxTypeEval = false;
        return;
      }
      const isVisible = $("#collapse-preview").is(":visible");
      OlabUtils.infoLog("selectedBoxType: isVisible = " + isVisible);
      if (isVisible) {
        $("#collapse-preview").collapse("toggle");
      }
      if (this.selectedBoxType == "") {
        return;
      }

      this.cstComp.setBoxType(this.selectedBoxType, true);
      // Reset primerObjArr since box may have changed
      this.primerObjArr = [];
      // Reset seq input
      this.selectedSeq = "";
      // Reset start and range inputs
      this.setupStartAndRange("", "");

      // Cleanup and return item to cart
      if (this.selectedBoxType == "unset") {
        this.cstComp.unsetItem(this.cartItems);
        this.selectedBoxType = "";
        this.filteredCartItems = [];
        // Set box's states into info as status
        OlabCstb.setInfoBox(this.cstComp);
        this.saveCstbs();
        return;
      }

      // Set selectable sequences
      this.filteredCartItems = OlabComp.filterCartItems(
        this.cstComp.item,
        this.selectedBoxType,
        this.cartItems
      );
    },
    numOfBoxes: function() {
      let remainingBoxes = this.numOfBoxes - this.cstComps.length;
      if (remainingBoxes == 0) {
        OlabUtils.infoLog(
          "numOfBoxes: remaining Boxes = " +
            remainingBoxes +
            ", numOfBoxes = " +
            this.numOfBoxes
        );
        return;
      } else if (remainingBoxes < 0) {
        OlabUtils.infoLog(
          "Report warning: remaining Boxes = " +
            remainingBoxes +
            ", numOfBoxes = " +
            this.numOfBoxes
        );
        if (this.cstComps[this.numOfBoxes].cstb.configured) {
          OlabUtils.infoLog("XXXX Report error: restored ....");
          this.numOfBoxes = this.lastNumOfBoxes;
          this.setBoxStyle(this.numOfBoxes);
          return;
        }
        // Resize unused boxes
        let tempCstComps = [];
        for (let i = 0; i < this.numOfBoxes; i++) {
          tempCstComps.push(this.cstComps[i]);
        }
        this.cstComps = tempCstComps;
        this.lastNumOfBoxes = this.numOfBoxes;
        this.setBoxStyle(this.numOfBoxes);
        this.saveCstbs();
        this.cstComp = this.cstComps[0];
        this.selectedBox = this.cstComp.cstb.box_id;
        OlabCstb.setInfoBox(this.cstComp);
        return;
      }
      this.doFillCstComps(this.cstComps.length, this.numOfBoxes, null);

      this.cstComp = this.cstComps[0];
      this.lastNumOfBoxes = this.numOfBoxes;
      this.setBoxStyle(this.numOfBoxes);
      this.saveCstbs();
    }
  },
  computed: {
    cartQty: function() {
      let qty = 0;
      if (this.selectedCart != null && this.selectedCart.comps != null) {
        for (let idx in this.selectedCart.comps) {
          qty = qty + this.selectedCart.comps[idx].qty;
        }
      }
      return qty;
    },
    cartIsFull: function() {
      return this.cartQty >= OlabUtils.MAX_ITEMS_PER_CART ? true : false;
    },
    selectedStartValidState: function() {
      if (
        this.cstComp == null ||
        !this.cstComp.cstb.configured ||
        this.selectedSeq == ""
      ) {
        return "";
      }
      return this.selectedStartValid ? "is-valid" : "is-invalid";
    },
    selectedRangeValidState: function() {
      if (
        this.cstComp == null ||
        !this.cstComp.cstb.configured ||
        this.selectedSeq == ""
      ) {
        return "";
      }
      return this.selectedRangeValid ? "is-valid" : "is-invalid";
    },
    decisionDisabledState: function() {
      let resultStr = "disabled";
      if (this.previewDisabledState == "" && this.primerObjArr.length > 0) {
        resultStr = "";
      }
      return resultStr;
    }
  },
  methods: {
    delayInSecond: function(sec) {
      return new Promise(resolve => setTimeout(resolve, sec * 1000));
    },
    reloadWorkaround: async function() {
      OlabUtils.infoLog("reloadWorkaround: zero seconds");
      this.counter = 0;
      await this.delayInSecond(3);
      OlabUtils.infoLog("reloadWorkaround: two seconds");
      if (this.selectedCart) {
        // FIX ME: push to Home to reset states for now
        this.$router.push("/");
      }
    },
    setBoxStyle: function(numBoxes) {
      if (numBoxes < 4) {
        // 3 or less
        this.boxStyle = {
          width: "180px",
          fontSize: "1em"
        };
      } else if (numBoxes < 6) {
        // between 4 and 5
        this.boxStyle = {
          width: "150px",
          fontSize: "0.9em"
        };
      } else if (numBoxes < 8) {
        // between 6 and 7
        this.boxStyle = {
          width: "110px",
          fontSize: "0.8em"
        };
      } else if (numBoxes < 10) {
        // between 8 and 9
        this.boxStyle = {
          width: "90px",
          fontSize: "0.7em"
        };
      } else {
        // 10
        this.boxStyle = {
          width: "80px",
          fontSize: "0.7em"
        };
      }
    },
    validateCst: function() {
      // OlabUtils.infoLog("validateCst: ....");
      let result = false;
      let index = 0;
      let firstPass = false;
      let unconfigAftPass = false;
      let breakInConfig = false;
      // Only preview properly configured construct
      this.cstComps.forEach(cstBox => {
        if (cstBox.cstb.configured) {
          if (index == 0) {
            firstPass = true;
          } else if (unconfigAftPass) {
            breakInConfig = true;
          }
        } else {
          if (firstPass) {
            unconfigAftPass = true;
          }
        }
        index++;
      });
      if (firstPass && !breakInConfig) {
        result = true;
      }

      const isVisible = $("#collapse-preview").is(":visible");
      // OlabUtils.infoLog("validateCst: isVisible = " + isVisible);

      if (!result && isVisible) {
        $("#collapse-preview").collapse("toggle");
      }
      this.previewDisabledState = result ? "" : "disabled";

      // Reset primerObjArr since box may have changed
      this.primerObjArr = [];
    },
    loadCstbs: function(cstbs) {
      OlabUtils.infoLog("loadCstbs ..." + cstbs);
      // Reset cstComp and cstComps
      this.cstComps = [];
      this.cstComp = null;
      this.initComps();
      this.doFillCstComps(0, cstbs.length, cstbs);
      this.numOfBoxes = cstbs.length;
      this.setBoxStyle(this.numOfBoxes);
      this.validateCst();
      // Special handling for genome package
      // TODO: FIX THIS Timeout
      setTimeout(() => {
        this.checkAndProcessGP();
      }, 100);
    },
    checkAndProcessGP: function() {
      OlabUtils.infoLog("checkAndProcessGP ....");
      if (this.cstComps) {
        for (let j = 0; j < this.cstComps.length; j++) {
          // Only do for genome package and override is true
          const ccp = this.cstComps[j];
          OlabUtils.infoLog(
            "ccp.cstb.configured = " +
              ccp.cstb.configured +
              ", ccp.cstb.package_override = " +
              ccp.cstb.package_override
          );

          if (ccp.cstb.configured && ccp.cstb.package_override) {
            // TODO: FIX THIS Timeout
            setTimeout(() => {
              if (ccp.item.seq && ccp.item.seq.comps) {
                const comps = ccp.item.seq.comps;
                for (let i = 0; i < comps.length; i++) {
                  const st = ccp.cstb.start;
                  const rg = ccp.cstb.range;
                  this.computeSequence(
                    comps[i].seqGene,
                    st,
                    rg,
                    null,
                    comps[i]
                  );
                }
              } else {
                OlabUtils.infoLog("NOT READY (2) = checkAndProcessGP ....");
              }
            }, 1000);
          }
        }
      } else {
        OlabUtils.infoLog("NOT READY (1) = checkAndProcessGP ....");
      }
      OlabUtils.infoLog("checkAndProcessGP .... done!!!");
    },
    saveCstbs: function() {
      OlabUtils.infoLog("saveCstbs ...");
      // Clear cstbs array
      this.selectedCart.cstbs.length = 0;
      for (let i = 0; i < this.cstComps.length; i++) {
        const cstb = this.cstComps[i].cstb;
        if (!cstb.configured) {
          cstb.btn_color = "unset-color";
        }
        this.selectedCart.cstbs.push(cstb);
      }
      this.validateCst();
      OlabCart.saveCart(this.selectedCart, this.selectedProject);
    },
    initComps: function() {
      OlabUtils.infoLog("initComps ...");
      // Only do this once when cartItems is null
      if (this.cartItems === null) {
        if (this.selectedCart && this.selectedCart.comps) {
          const ccArr = [];
          const comps = this.selectedCart.comps;
          for (let i = 0; i < comps.length; i++) {
            const cp = comps[i];
            const cc = new OlabComp(cp);
            ccArr.push(cc);
          }
          this.cartItems = ccArr;
          OlabUtils.infoLog("cartItems.length = " + this.cartItems.length);
        }
      } else {
        OlabUtils.infoLog(
          "Nothing done. CartItems was initialized. : length = " +
            this.cartItems.length
        );
      }
    },
    getSeqLength: function(item) {
      let len = 0;
      if (item) {
        len = item.getSeqLength();
      }
      return len;
    },
    getCartItemIndex: function(seqItem) {
      // OlabUtils.infoLog("getCartItemIndex: seqItem = " + seqItem);
      let index = 0;
      if (seqItem && this.cartItems) {
        // const id = seqItem.substr(0, seqItem.indexOf(" "));
        const id = seqItem;
        // OlabUtils.infoLog("getCartItemIndex: id = " + id);
        for (let i = 0; i < this.cartItems.length; i++) {
          if (this.cartItems[i].comp.olab_id == id) {
            index = i;
            break;
          }
        }
      }
      // OlabUtils.infoLog("**** getCartItemIndex: index = " + index);
      return index;
    },
    resetStartAndRange: function() {
      this.setupStartAndRange("", "");
    },
    computeLibrarySequence: function() {
      let start = Number(this.selectedStart);
      let range = Number(this.selectedRange);
      OlabUtils.infoLog("start = " + start + ", range = " + range);

      // OlabUtils.infoLog("seq = " + this.cstComp.item.sequence.seq);
      let subSeq = this.cstComp.item.seq.seq.substr(start, range);
      // OlabUtils.infoLog("subSeq = " + subSeq);

      this.cstComp.setSeq(subSeq);
    },
    computeSequence: function(seq, start, range, ccp, cmp) {
      OlabUtils.infoLog("start = " + start + ", range = " + range);

      this.blockConfig = OlabBlock.getConfigBlock(
        seq.olab_id,
        this.dbInfo.db_configs.block_configs
      );

      if (!this.blockConfig) {
        if (ccp) {
          ccp.setSeq(seq.sequence.seq);
        } else {
          cmp.seq = seq.sequence.seq;
          OlabUtils.infoLog("Genome Package: seq = " + cmp.seq);
        }
        return;
      }

      const cstCompSeq = seq.sequence.seq;
      const cstCompSeqLen = cstCompSeq.length;
      OlabUtils.infoLog(
        "cstCompSeq = " + cstCompSeq + ", cstCompSeqLen = " + cstCompSeqLen
      );

      if (start >= 0 && start + range <= cstCompSeqLen) {
        // Handle simple case where seq can be extracted from cstCompSeq
        const seqFrag = cstCompSeq.substr(start, range);
        if (ccp) {
          ccp.setSeq(seqFrag);
        } else {
          cmp.seq = seqFrag;
        }
      } else {
        OlabBlock.computeSequence(
          seq,
          start,
          range,
          this.blockConfig,
          ccp,
          cmp
        );
      }
    },
    doFillCstComps: function(start, end, cstbs) {
      for (let i = start; i < end; i++) {
        const cstBox = new OlabCstb(i + 1);
        if (cstbs && cstbs.length > i) {
          // TODO: Setting package_op and package_override is to update old data
          // Remove this code block when old data is updated
          OlabUtils.infoLog("cstbs[i].package_op = " + cstbs[i].package_op);
          if (!cstbs[i].package_op) {
            cstbs[i].package_op = "combination";
            cstbs[i].package_override = false;
            OlabUtils.infoLog("Set ... " + cstbs[i].package_op);
          }

          cstBox.cstb = cstbs[i];
          // Set cstBox's item
          cstBox.setItem(this.cartItems);
        }
        this.cstComps.push(cstBox);
      }
    },
    setupStartAndRange: function(olabType, itemSeq) {
      if (olabType == "") {
        // Reset and disable start and range
        this.selectedStartDisabledState = "disabled";
        this.selectedStartHelp = "";
        this.selectedRangeDisabledState = "disabled";
        this.selectedRangeHelp = "";
        if (this.selectedStart != "--") {
          this.selectedStart = "--";
          this.noStartEval = true;
        }
        if (this.selectedRange != "--") {
          this.selectedRange = "--";
          this.noRangeEval = true;
        }
      } else if (olabType == "strain") {
        this.selectedStartDisabledState = "";
        this.selectedStartHelp = "Start is at the begining of sequence";
        this.selectedRangeDisabledState = "";
        this.selectedRangeHelp =
          "Number of bases to the right of Start. Range is limited to 20000.";
      } else if (olabType == "library_sequence") {
        // Disable setting for start and range
        this.selectedStartDisabledState = "disabled";
        this.selectedRangeDisabledState = "disabled";
        this.selectedStartHelp = "Setting is N/A for Library sequence";
        this.selectedRangeHelp = "Setting is N/A for Library sequence";
      } else if (
        olabType == "package" &&
        itemSeq &&
        itemSeq.package_seq_type == "library_sequence"
      ) {
        // Disable setting for start and range
        this.selectedStartDisabledState = "disabled";
        this.selectedRangeDisabledState = "disabled";
        this.selectedStartHelp = "N/A for Library Sequence Package";
        this.selectedRangeHelp = "N/A for Library Sequence Package";
        if (this.selectedStart != "--") {
          this.selectedStart = "--";
          this.noStartEval = true;
        }
        if (this.selectedRange != "--") {
          this.selectedRange = "--";
          this.noRangeEval = true;
        }
      } else if (
        olabType == "package" &&
        itemSeq &&
        itemSeq.package_seq_type == "genome"
      ) {
        if (this.selectedOverride) {
          this.selectedStartDisabledState = "";
          this.selectedStartHelp = "Start is at the begining of sequence";
          this.selectedRangeDisabledState = "";
          this.selectedRangeHelp =
            "Number of bases to the right of Start. Range is limited to 20000.";
          // Reset noStartEval and noRangeEval
          this.noStartEval = false;
          this.noRangeEval = false;
        } else {
          this.selectedStartDisabledState = "disabled";
          this.selectedRangeDisabledState = "disabled";
          this.selectedStartHelp = "Use respective gene start";
          this.selectedRangeHelp = "Use respective gene range";
          if (this.selectedStart != "--") {
            this.selectedStart = "--";
            this.noStartEval = true;
          }
          if (this.selectedRange != "--") {
            this.selectedRange = "--";
            this.noRangeEval = true;
          }
        }
      } else if (olabType == "unknown") {
        // Disable setting for start and range
        this.selectedStartDisabledState = "disabled";
        this.selectedStartHelp = "Setting is unsupported for this sequence";
        this.selectedRangeDisabledState = "disabled";
        this.selectedRangeHelp = "Setting is unsupported for this sequence";
      }
      // Copy start and range to cstb
      this.cstComp.cstb.start = this.selectedStart;
      this.cstComp.cstb.range = this.selectedRange;
    },
    resetNoEvalFlags: function() {
      this.noBoxTypeEval = false;
      this.noSeqEval = false;
      this.noStartEval = false;
      this.noRangeEval = false;
      this.noOverrideEval = false;
    },
    registerCstComp: function(ccp) {
      OlabUtils.infoLog(
        "registerCstComp: ccp = " +
          ccp.cstb.display_name +
          ", selectedBox = " +
          this.selectedBox
      );
      const isHidden = $("#collapse-construct").is(":hidden");
      if (isHidden) {
        $("#collapse-construct").collapse("toggle");
      }
      OlabUtils.infoLog("registerCstComp: isHidden = " + isHidden);

      this.resetNoEvalFlags();

      if (ccp == this.lastCstComp) {
        OlabUtils.infoLog("registerCstComp: ccp == this.lastCstComp");
        return;
      }

      this.cstComp = ccp;
      this.selectedBox = this.cstComp.cstb.box_id;

      // Reset last Box that didn't complete the configuration steps
      if (
        this.cstComp != this.lastCstComp &&
        this.lastCstComp &&
        this.lastCstComp.cstb.configured != true
      ) {
        this.lastCstComp.cstb.btn_color = "unset-color";
        this.lastCstComp.cstb.display_name =
          "Box " + this.lastCstComp.cstb.box_id;
      }

      OlabUtils.infoLog(
        "** cstComp configured = " + this.cstComp.cstb.configured
      );
      if (this.cstComp.cstb.configured == false) {
        this.cstComp.cstb.btn_color = "selected-color";
        // Reset Inputs
        this.selectedBoxType = "";
        this.selectedSeq = "";
        this.filteredCartItems = [];
        this.setupStartAndRange("", "");
      } else {
        // Set Inputs and eval flags
        if (this.selectedBoxType != this.cstComp.cstb.box_type) {
          this.noBoxTypeEval = true;
          this.selectedBoxType = this.cstComp.cstb.box_type;
        }
        // Set selectable sequences
        this.filteredCartItems = OlabComp.filterCartItems(
          this.cstComp.item,
          this.selectedBoxType,
          this.cartItems
        );
        if (this.selectedSeq != this.cstComp.cstb.comp_olab_id) {
          this.noSeqEval = true;
          this.selectedSeq = this.cstComp.cstb.comp_olab_id;
        }
        if (this.selectedStart != this.cstComp.cstb.start) {
          this.noStartEval = true;
          this.selectedStart = this.cstComp.cstb.start;
        }
        if (this.selectedRange != this.cstComp.cstb.range) {
          this.noRangeEval = true;
          this.selectedRange = this.cstComp.cstb.range;
        }
        if (this.selectedOverride != this.cstComp.cstb.package_override) {
          this.noOverrideEval = true;
          this.selectedOverride = this.cstComp.cstb.package_override;
        }
        this.setupStartAndRange(
          this.cstComp.item.comp.olab_type,
          this.cstComp.item.seq
        );
      }

      // Set box's states into info as status
      OlabCstb.setInfoBox(this.cstComp);
      // this.saveCstbs();

      // Set selectable box types
      OlabComp.computeAvailBoxType(this.cstComp.cstb.box_type, this.cartItems);

      this.lastCstComp = this.cstComp;
    },
    doPreview: function(force) {
      this.pmrObjIndex = 0;
      let prObjArr = [];
      if (!force) {
        const isVisible = $("#collapse-preview").is(":visible");
        OlabUtils.infoLog("doPreview: isVisible = " + isVisible);
        if (isVisible) {
          // No computation is needed since it is already visible
          return;
        }
        this.dsgn.processing = "preview";
        setTimeout(() => {
          OlabUtils.infoLog("setTimeout to 10ms");
          this.dsgn.computePrimersV2(this.cstComps, prObjArr);
          this.dsgn.processing = "";
        }, 10);
      } else {
        this.dsgn.computePrimersV2(this.cstComps, prObjArr);
      }

      this.primerObjArr = prObjArr;

      this.commitDesignDisabledState = "";
      this.resetDisabledState = "";
    },
    removeNullPrimers: function(pmrs) {
      const resultPmrs = [];
      for (let i = 0; i < pmrs.length; i++) {
        if (pmrs[i].seq) {
          resultPmrs.push(pmrs[i]);
        }
      }
      return resultPmrs;
    },
    computeDesignPrimers: function() {
      let cstArray = [];
      let combPmrArray = [];
      for (let i = 0; i < this.primerObjArr.length; i++) {
        cstArray.push(this.primerObjArr[i]);
        const backwards = this.primerObjArr[i].backwards;
        const forwards = this.primerObjArr[i].forwards;
        // OlabUtils.infoLog("backwards.length = " + backwards.length + ", forwards.length = " + forwards.length);

        // Add remove null primers as a preprocessing to improve performance
        const bwds = this.removeNullPrimers(backwards);
        const fwds = this.removeNullPrimers(forwards);

        // combPmrArray = _.concat(combPmrArray, bwds, fwds);
        // Performance fix: push.apply (to merge arrays) is significantly faster than concat here.
        // NOTE: Do not use this method if the second array is very large
        combPmrArray.push.apply(combPmrArray, bwds);
        combPmrArray.push.apply(combPmrArray, fwds);
      }

      // Only contains unique seqs
      const uniqPmrArray = _.uniqBy(combPmrArray, "seq");

      this.dsgn.cstArray = cstArray;
      this.dsgn.combPmrArray = combPmrArray;
      this.dsgn.uniqPmrArray = uniqPmrArray;
      OlabUtils.infoLog(
        "uniqPmrArray.length = " + this.dsgn.uniqPmrArray.length
      );
      OlabUtils.infoLog(
        "combPmrArray.length = " + this.dsgn.combPmrArray.length
      );
    },
    doDecision: function() {
      // OlabUtils.infoLog("doDecision");
      // OlabUtils.infoLog("Number of Constructs (primerObjArr) = " + this.primerObjArr.length);
      const isVisible = $("#collapse-decision").is(":visible");
      OlabUtils.infoLog("doDecision: isVisible = " + isVisible);
      if (isVisible) {
        // No computation is needed since it is already visible
        return;
      }

      this.dsgn.processing = "decision";
      setTimeout(() => {
        OlabUtils.infoLog("setTimeout to 10ms");
        this.computeDesignPrimers();
        this.dsgn.processing = "";
      }, 10);
    },
    downloadCSV(dlType) {
      // Prepare primers for export
      // Construct primer objects for output
      let fileName = this.dsgn.name;
      let dlPrimerArr = [];
      if (dlType == "full") {
        fileName += "_Full_Primers.csv";
        dlPrimerArr = this.dsgn.getAllPrimers();
      } else if (dlType == "order") {
        fileName += "_Order_Primers.csv";
        dlPrimerArr = this.dsgn.getOrderPrimers();
      }

      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";

      // const json = JSON.stringify(dlPrimerArr);
      // OlabUtils.infoLog("json = " + json);
      // const blob = new Blob([json], {type: "octet/stream"});

      let opt = "";
      const csv = OlabDownload.obj2csv(dlPrimerArr, opt);
      // OlabUtils.infoLog("csv = " + csv);
      const blob = new Blob([csv], { type: "octet/stream" });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    doDownload(dlType) {
      this.selectedDownload = dlType;
      OlabUtils.infoLog(
        "doDownload ... selectedDownload = " + this.selectedDownload
      );
      this.dsgn.processing = "download";
      setTimeout(() => {
        OlabUtils.infoLog("setTimeout to 10ms");
        this.downloadCSV(dlType);
        this.dsgn.processing = "";
      }, 10);
    },
    doCommitDesign() {
      // OlabUtils.infoLog("doCommitDesign ... ");
      this.dsgn.processing = "commit";
      this.dsgn.name = this.dsgnName.slice(0);
      // Save design to design database
      OlabDesign.saveDesign(this.dsgn);
      // Also save design name to name to cart
      this.selectedCart.design_name = this.dsgn.name;
      OlabCart.saveCart(this.selectedCart, this.selectedProject);
      this.commitDesignDisabledState = "disabled";
    },
    doReset() {
      // OlabUtils.infoLog("doReset ... ");
      // Reset primerObjArr
      this.primerObjArr = [];

      this.selectedBoxType = "unset";
      for (let i = 0; i < this.cstComps.length; i++) {
        this.cstComp = this.cstComps[i];
        this.cstComp.setBoxType(this.selectedBoxType, true);

        // Cleanup and return item to cart
        this.cstComp.unsetItem(this.cartItems);
        this.filteredCartItems = [];
        // Set box's states into info as status
        OlabCstb.setInfoBox(this.cstComp);
      }
      this.saveCstbs();
      this.cstComp = this.cstComps[0];
      this.selectedBoxType = "";

      // Reset cst and pmr arrays in dsgn
      this.dsgn.cstArray.length = 0;
      this.dsgn.combPmrArray.length = 0;
      this.dsgn.uniqPmrArray.length = 0;
      this.resetDisabledState = "disabled";
    }
  }
};
</script>

<style lang="scss">
.page-design {
  background-color: lightcyan;
}
.unset-color {
  color: lightgoldenrodyellow;
  font-size: 0.7em;
  width: 80px;
  height: 38px;
  background-color: rgb(160, 160, 160);
}
.selected-color {
  color: lightgoldenrodyellow;
  font-size: 0.7em;
  width: 80px;
  height: 38px;
  background-color: rgb(221, 3, 3);
}
.upstream-color-sm {
  color: lightgoldenrodyellow;
  font-size: 0.7em;
  width: 80px;
  height: 38px;
  background-color: rgb(199, 130, 87);
}
.upstream-color {
  color: lightgoldenrodyellow;
  font-size: 1em;
  background-color: rgb(199, 130, 87);
}
.promoter-color-sm {
  color: lightgoldenrodyellow;
  font-size: 0.7em;
  width: 80px;
  height: 38px;
  background-color: rgb(117, 190, 54);
}
.promoter-color {
  color: lightgoldenrodyellow;
  font-size: 1em;
  background-color: rgb(117, 190, 54);
}
.rbs-color-sm {
  color: lightgoldenrodyellow;
  font-size: 0.7em;
  width: 80px;
  height: 38px;
  background-color: rgb(182, 47, 223);
}
.rbs-color {
  color: lightgoldenrodyellow;
  font-size: 1em;
  background-color: rgb(182, 47, 223);
}
.gene-color-sm {
  color: lightgoldenrodyellow;
  font-size: 0.7em;
  width: 80px;
  height: 38px;
  background-color: rgb(78, 185, 184);
}
.gene-color {
  color: lightgoldenrodyellow;
  font-size: 1em;
  background-color: rgb(78, 185, 184);
}
.pgst-color-sm {
  color: lightgoldenrodyellow;
  font-size: 0.7em;
  width: 80px;
  height: 38px;
  background-color: rgb(75, 100, 180);
}
.pgst-color {
  color: lightgoldenrodyellow;
  font-size: 1em;
  background-color: rgb(75, 100, 180);
}
.terminator-color-sm {
  color: lightgoldenrodyellow;
  font-size: 0.7em;
  width: 80px;
  height: 38px;
  background-color: rgb(129, 75, 190);
}
.terminator-color {
  color: lightgoldenrodyellow;
  font-size: 1em;
  background-color: rgb(129, 75, 190);
}
.downstream-color-sm {
  color: lightgoldenrodyellow;
  font-size: 0.7em;
  width: 80px;
  height: 38px;
  background-color: rgb(197, 74, 74);
}
.downstream-color {
  color: lightgoldenrodyellow;
  font-size: 1em;
  background-color: rgb(197, 74, 74);
}
</style>
